import {getColor} from "@/styles/ThemeConfig";
import styled, {css} from "styled-components";
import ForceSSRLink from "@/components/other/ForceSSRLink";

import {breakpoints} from "@/styles/sizes";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";

const GreyBlock = styled.div`
  display: flex;
  justify-content: space-between;
    align-items: center;
  background-color: ${getColor('grayBackground')};
  padding: 10px 20px;
`;

const Right = styled.div`
  flex: 1;
  text-align: left;
`;

const Item = styled.div`
    display: flex;
    gap: 5px;
    align-items: flex-start;
    
    img{
        margin-top: 4px;
    }
    
  margin-bottom: 10px;
  
  p {
    font-size: 16px;
    margin: 0;
      font-family: Verdana, sans-serif!important;
  }

  span {
    font-family: Verdana, sans-serif!important;
  }

  a {
      font-family: Verdana, sans-serif!important;
    color: blue;
    text-decoration: none;
  }
`;

const TourMeetingSectionWrapper = styled.div`
    background: white;
    padding: 50px;
    @media only screen and (${breakpoints.mobile}) {
        padding: 40px 20px;
    }
`;

const IframeEmbed = styled.div`
    iframe {
        width: 100%;
        height: 300px;
        border: none;
        outline: none;
        display: block; /* removes inline gap/whitespace */
    }
`;

const SpotsWrapper = styled.div`
    display: grid;
    grid-template-columns:1fr 1fr;
    gap:10px;

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns:1fr;
    }
`;

const Title = styled.h2`
    text-transform: uppercase;
    margin-top: 20px;
    margin-bottom: 20px;
    color: ${getColor('gold')};
    font-weight: bold;
    text-align:center;
    font-size:36px!important;

    @media only screen and (${breakpoints.mobile}) {
        font-size:25px;
    }
`;

export default function VariantBMeetingSpotsSection({title,description,email,spots,isUpgrade,guideInfo, fullyBooked, fullyBookedText, cityName, ...rest})
{
    return (
        (title ||
            description ||
            email ||
            spots ||
            isUpgrade ||
            guideInfo ||
            fullyBooked ||
            fullyBookedText) &&<TourMeetingSectionWrapper id={'CONTACT'} {...rest}>



            {title && <Title className={'h4'} style={{

            }}>{title}</Title>}
            {description && <DangerousDescriptionWrapper
                customStyle={css`
                    font-family: 'Inter'!important;
                font-size: 16px !important;
                    max-width: 800px;
                    margin:auto;
                    margin-bottom: 20px;
                    text-align: center;
                    *{
                        font-family: 'Inter'!important;
                    }
                    @media only screen and (${breakpoints.mobile}) {
                        padding:0;
                    }
            `}
                dangerouslySetInnerHTML={{__html: description}}
            />}


            {spots && <SpotsWrapper>{spots?.map((item, index) => {
                return <div
                    key={index}
                >
                    {item?.embed && <IframeEmbed dangerouslySetInnerHTML={{__html:item?.embed}} />}

                    {
                        (item?.dayFrom ||
                            item?.dayTo ||
                            item?.locationLink ||
                            item?.location)
                        && <GreyBlock>
                            <Right>
                                <Item>
                                    <div>
                                        <p
                                            style={{
                                                fontFamily:'Inter',
                                                fontWeight:700,
                                                color: 'black',
                                            }}
                                        >
                                            {item?.location}
                                        </p>
                                        <ForceSSRLink
                                            href={item?.locationLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                fontFamily:'Inter',
                                                color: 'black',
                                                textDecoration:'underline',
                                            }}
                                        >
                                            See on Google Maps
                                        </ForceSSRLink>
                                        <p>{item?.dayFrom} {item?.dayTo && '-'} {item?.dayTo} <span style={{}}>{item?.dayHelpText}</span></p>
                                    </div>

                                </Item>
                            </Right>
                        </GreyBlock>
                    }
                </div>
            })}</SpotsWrapper>}

            {
                !isUpgrade && <>
                    <div style={{
                        fontSize: '16px',
                        fontFamily: 'Inter',
                        margin: '20px 0',
                        textAlign:'center',
                    }}>
                        {guideInfo}
                    </div>

                </>
            }

        </TourMeetingSectionWrapper>
    )

}
